import React, { useEffect, useState } from "react";
import "./home.css";
import UserNavbar from "../UserNavbar/UserNavbar";
import { Outlet } from "react-router-dom";

const Home = () => {
  const [location, setLocation] = useState(null);
  const [locationName, setLocationName] = useState('');

  const detectGPS = () => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        setLocation({ lat: latitude, lon: longitude });
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
          );
          const data = await res.json();
          const city =
            data.address?.city ||
            data.address?.town ||
            data.address?.village ||
            data.address?.suburb ||
            'Near You';
          setLocationName(city);
        } catch {
          setLocationName('Near You');
        }
      },
      (err) => {
        console.warn("User denied location:", err);
        setLocation(null);
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  useEffect(() => {
    detectGPS();
  }, []);

  return (
    <div className="home-container">
      <div className="home_content">
        <UserNavbar
          location={location}
          setLocation={setLocation}
          locationName={locationName}
          setLocationName={setLocationName}
        />
        <div className="inside_homecontain">
          <Outlet context={{ location, setLocation, locationName, setLocationName }} />
        </div>
      </div>
    </div>
  );
};

export default Home;
